import styled from "styled-components";

export const EditVehicleWrapper = styled.div`
  .input-fileds textarea {
    border: 1px solid #979797;
    border-radius: 4px;
  }
  .form-control {
    border: 1px solid #ced4da !important;
    appearance: none !important;
    border-radius: 0.25rem !important;
  }
  .headerContainer {
    justify-content: center !important;
  }
  .colorBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #979797;
    border-radius: 4px;
    padding: 0px 10px;
  }
  .colorBox input {
    border: none;
    width: 20%;
    height: 34px;
  }
  select {
    border: 1px solid #ced4da !important;
  }
  .input-fileds img {
    width: 25px;
    height: 25px;
  }
  .input-fileds button {
    border: none;
    background: transparent;
    color: #5d78ff;
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
  // textarea {
  //   resize: none;
  // }
  .save-btn h4 {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
  .add-button {
    white-space: nowrap;
    float: right;
    border: none !important;
    border-radius: 5px;
    background: #fbc524 !important;
    color: #fff !important;
    font-weight: 500;
    font-size: 16px;
    font-weight: bold;
    line-height: 19px;
    padding: 0 20px;
    height: 35px;
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
  .add-button:hover {
    background: #637df4;
    color: white;
  }
  select {
    border: 1px solid #979797;
    border-radius: 4px;
  }
  .fileInput {
    display: none;
  }
  .percentage {
    font-size: 12px;
    font-style: italic;
    font-weight: 100;
  }
  .suggested-labels{
    margin-top: 30px;
    ul{
      margin-top: 10px;
      li{
        margin: 4px 0 15px;
        span{
          border: 1px solid #607afc;
          color: #607afc;
          font-weight: 600;
          width: max-content;
          padding: 0px 4px 2px;
          border-radius: 4px;
        }
        img{
          cursor: pointer;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .product-type {
      margin-top: 15px;
    }
  }
`;
